// @flow
/**
 * Created by ivo on 08.01.17.
 *
 */
import t from './trans';

let PARSED_FIELDS =  [
    "ridu",
    "joonx1",
    "joonx2",
    "joony1",
    "joony2"
];

/**
 *
 * Common abstract class for parsing Glass data files
 */
class GlassFileParser {
    constructor(isRotated) {
        this.resetParser();
    }

    /**
     * Parse glass info file and return parsed structure
     * @param {string} data Glass info file content as string
     * @returns {{}} Glass info structure as follows:
     *      {
     *          "ridu": intVal
     *          "joonx1": array,
     *          "joonx2": array,
     *          "joony1": array,
     *          "joony2": array,
     *      }
     */
    parse(data) {
        this.resetParser();
        this.setInputData(data);
        this.parseData();
        this.resetInputData();
        return this.getParsedData();
    }

    /**
     * Child classes should overwrite this method and implement actual file parsing here.
     * Class should read data with the help of method this.readLine() (this method throws when trying to read
     * over the file end) and assign appropriate values for object fields.
     * @returns {{}}
     */
    parseData() {
        // Child classes should overwrite this method
        return {};
    }

    resetParser() {
        // Ajutine sisseloetava faili ridade massiiv
        this.lines = null;
        // Hetkel parsitava faili rea number
        this.lineno = 0;

        this.joonx1 = [];
        this.joonx2 = [];
        this.joony1 = [];
        this.joony2 = [];
        this.ridu = 0;
    }

    getParsedData() {
        let result = {};
        for (let item of PARSED_FIELDS) {
            result[item] = this[item];
        }
        return result;
    }

    setInputData(data) {
        this.lines = data.split(/\r?\n/);
        this.lineno = 0;
    }

    resetInputData() {
        this.lines = null;
    }

    readLine() {
        if (this.lines.length == 0) throw t("Unexpected end of data");
        let l = this.lines.shift();
        this.lineno++;
        return l;
    }

}

export default GlassFileParser;
